import React from 'react';
import cn from 'classnames';

import classes from './Form.module.scss';

const ItemInline = ({ endItemSection, endSection, children, className }) => {
  return (
    <div
      className={cn(classes.itemInline, className, {
        [classes.endItemSection]: endItemSection,
        [classes.endSection]: endSection,
      })}
    >
      {children}
    </div>
  );
};

export default ItemInline;
